import { resolveAvailabilityDays } from "./availabilityDays";
import { resolveAvailabilityShifts } from "./availabilityShifts";

export type FanOutSvc = {
  id: number;
  availabilityDays?: number[] | null;
  availabilityShifts?: string[] | null;
};

export type AvailabilityRowInput = {
  date: string;
  available: true;
  svcId: number;
  shift: string;
  vehicleId: number;
  assignedToday: false;
  driverId: string;
};

/**
 * Producto cartesiano días × SVCs × turnos × vehículos para POST /availabilities,
 * salteando (día, SVC) si el día no está habilitado en ese SVC, (turno, SVC) si
 * el turno no lo está, y (día, turno) cuando `skipShiftsByDate` lo indica (ruta ya
 * asignada). Antes vivía duplicado en ReportAvailability (crear y editar).
 */
export const buildAvailabilityRows = (params: {
  days: string[];
  svcs: FanOutSvc[];
  shifts: string[];
  vehicleIds: number[];
  driverId: string;
  skipShiftsByDate?: Map<string, string[]>;
}): AvailabilityRowInput[] => {
  const { days, svcs, shifts, vehicleIds, driverId, skipShiftsByDate } = params;
  const rows: AvailabilityRowInput[] = [];
  for (const date of days) {
    const [yy, mm, dd] = date.split("-").map(Number);
    const weekday = new Date(yy, mm - 1, dd).getDay();
    for (const svc of svcs) {
      if (!resolveAvailabilityDays(svc.availabilityDays).includes(weekday)) continue;
      const allowedShifts = resolveAvailabilityShifts(svc.availabilityShifts);
      for (const shift of shifts) {
        if (!allowedShifts.includes(shift)) continue;
        if (skipShiftsByDate?.get(date)?.includes(shift)) continue;
        for (const vehicleId of vehicleIds) {
          rows.push({ date, available: true, svcId: svc.id, shift, vehicleId, assignedToday: false, driverId });
        }
      }
    }
  }
  return rows;
};
